import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule, DatePipe, registerLocaleData } from "@angular/common";
import localePt from '@angular/common/locales/pt';
import { LOCALE_ID, NgModule } from "@angular/core";
import { FlexLayoutModule } from "@angular/flex-layout";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatAutocompleteModule, MatBadgeModule, MatExpansionModule, MatGridListModule, MatIconModule, MatListModule, MatMenuModule, MatPaginatorModule, MatProgressBarModule, MatProgressSpinnerModule, MatRadioModule, MatRippleModule, MatSidenavModule, MatSlideToggleModule, MatSnackBarModule, MatSortModule, MatTableModule, MatTabsModule, MatToolbarModule, MatTooltipModule, MatTreeModule } from "@angular/material";
import { MatButtonModule } from "@angular/material/button";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatDividerModule } from "@angular/material/divider";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatStepperModule } from "@angular/material/stepper";
import { RouterModule } from '@angular/router';
import { TextMaskModule } from "angular2-text-mask";
import { ComponentsModule } from 'app/core/ui/components/components.module';
import { ModalService } from 'app/tools/modal/modal.service';
import { IconeSituacaoValidade } from 'app/tools/pipes/logico/iconeSituacaoValidade.pipe';
import { AutocompleteAgenteAitTaxiComponent } from 'app/view/ait/ait-taxi/ait-taxi-form/components/autocomplete-agente-ait-taxi/autocomplete-agente-ait-taxi.component';
import { AutocompleteInfracaoComponent } from 'app/view/ait/ait-taxi/ait-taxi-form/components/autocomplete-infracao/autocomplete-infracao.component';
import { TextNumeroAitFormComponent } from 'app/view/ait/ait-taxi/ait-taxi-form/components/text-numero-ait-form/text-numero-ait-form.component';
import { TextObservacaoInfracaoComponent } from 'app/view/ait/ait-taxi/ait-taxi-form/components/text-observacao-infracao/text-observacao-infracao.component';
import { TipoTalaoComponent } from 'app/view/ait/ait-taxi/ait-taxi-form/components/tipo-talao/tipo-talao.component';
import { DropdownSituacaoAitComponent } from 'app/view/ait/ait-taxi/ait-taxi-search/components/dropdown-situacao-ait/dropdown-situacao-ait.component';
import { TextDataEntregaComponent } from 'app/view/ait/talonario-ait/shared/components/text-data-entrega/text-data-entrega.component';
import { TextNumeroFinalComponent } from 'app/view/ait/talonario-ait/shared/components/text-numero-final/text-numero-final.component';
import { TextNumeroInicialComponent } from 'app/view/ait/talonario-ait/shared/components/text-numero-inicial/text-numero-inicial.component';
import { TextNumeroTalaoComponent } from 'app/view/ait/talonario-ait/shared/components/text-numero-talao/text-numero-talao.component';
import { DropdownTalonarioTipoComponent } from 'app/view/ait/talonario-ait/talonario-ait-form/components/dropdown-talonario-tipo/dropdown-talonario-tipo.component';
import { GridRecursosComponent } from 'app/view/concessao/coletivo-urbano/shared/grid-recursos/grid-recursos.component';
import { DropdownSituacaoConcessaoComponent } from 'app/view/concessao/components/dropdown-situacao-concessao/dropdown-situacao-concessao.component';
import { TextInscricaoMunicipalComponent } from 'app/view/concessao/components/text-inscricao-municipal/text-inscricao-municipal.component';
import { TextNrAitComponent } from 'app/view/concessao/shared/components/text-nr-ait/text-nr-ait.component';
import { AutocompletePlacaEscolarComponent } from 'app/view/concessao/shared/mob/vistoria/autocomplete-placa-escolar/autocomplete-placa-escolar.component';
import { AutocompletePlacaMototaxiComponent } from 'app/view/concessao/shared/mob/vistoria/autocomplete-placa-mototaxi/autocomplete-placa-mototaxi.component';
import { AutocompleteVistoriaConcessionarioEscolarComponent } from 'app/view/concessao/shared/mob/vistoria/autocomplete-vistoria-concessionario-escolar/autocomplete-vistoria-concessionario-escolar.component';
import { AutocompleteVistoriaConcessionarioMototaxiComponent } from 'app/view/concessao/shared/mob/vistoria/autocomplete-vistoria-concessionario-mototaxi/autocomplete-vistoria-concessionario-mototaxi.component';
import { AutocompleteVistConcessionarioComponent } from 'app/view/concessao/shared/mob/vistoria/autocomplete-vistoriado-rural/autocomplete-vist-concessionario.component';
import { DropdownEnderecoComponent } from 'app/view/concessao/shared/mob/vistoria/dropdown-endereco/dropdown-endereco.component';
import { DropdownPlacaRuralComponent } from 'app/view/concessao/shared/mob/vistoria/dropdown-placa-rural/dropdown-placa-rural.component';
import { ButtonAtivarComponent } from 'app/view/concessao/shared/pessoa-fisica-form/components/button-ativar/button-ativar.component';
import { ButtonCancelarComponent } from 'app/view/concessao/shared/pessoa-fisica-form/components/button-cancelar/button-cancelar.component';
import { ButtonDesativarComponent } from 'app/view/concessao/shared/pessoa-fisica-form/components/button-desativar/button-desativar.component';
import { ButtonEditarComponent } from 'app/view/concessao/shared/pessoa-fisica-form/components/button-editar/button-editar.component';
import { ButtonSalvarSituacaoComponent } from 'app/view/concessao/shared/pessoa-fisica-form/components/button-salvar-situacao/button-salvar-situacao.component';
import { ButtonSalvarComponent } from 'app/view/concessao/shared/pessoa-fisica-form/components/button-salvar/button-salvar.component';
import { DateAtivacaoComponent } from 'app/view/concessao/shared/pessoa-fisica-form/components/date-ativacao/date-ativacao.component';
import { DateFinalSituacaoComponent } from 'app/view/concessao/shared/pessoa-fisica-form/components/date-final-situacao/date-final-situacao.component';
import { DateInativacaoComponent } from 'app/view/concessao/shared/pessoa-fisica-form/components/date-inativacao/date-inativacao.component';
import { DropdownSituacaoComponent } from 'app/view/concessao/shared/pessoa-fisica-form/components/dropdown-situacao/dropdown-situacao.component';
import { GridDocumentosComponent } from 'app/view/concessao/shared/pessoa-fisica-form/components/grid-documentos/grid-documentos.component';
import { ModalDesativarComponent } from 'app/view/concessao/shared/pessoa-fisica-form/components/modal-desativar/modal-desativar.component';
import { AutoCompleteNomePermissionarioComponent } from 'app/view/concessao/taxi/components/auto-complete-nome-permissionario/auto-complete-nome-permissionario.component';
import { TextNumeroInfracaoTaxiComponent } from 'app/view/concessao/taxi/infracoes/taxi-infracao-search/components/text-numero-infracao-taxi/text-numero-infracao-taxi.component';
import { AnexarFotoAlvaraComponent } from 'app/view/concessao/taxi/taxi-form/components/anexar-foto-alvara/anexar-foto-alvara.component';
import { AutocompleteVistoriadoFilterComponent } from 'app/view/relatorios/relatorio-vistoria/relatorio-vistoria-search/components/autocomplete-vistoriado-filter/autocomplete-vistoriado-filter.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { NgxMaskModule } from 'ngx-mask';
import { SolComponentsAngularModule } from "sol-components-angular/dist";
import { SolToolsModule } from "sol-tools-ts/dist";
import { DialogFactory } from 'sol-tools-ts/dist/dialog/dialog-factory';
import { LoginController } from "../controllers/seg/login.controller";
import { InputNormalizeDirective } from '../tools/InputNormalizeDirective';
import { MOMENT_DATE_FORMATS, MomentDateAdapter } from '../tools/date-adapter';
import { InputDateDirective } from '../tools/directives/input-date.directive';
import { LabelFunctionPipe } from "../tools/label-function-pipe";
import { ButtonNovoAitTransporteComponent } from '../view/concessao/coletivo-urbano/ait-transporte/ait-transporte-search/components/button-novo-form/button-novo.component';
import { ButtonNovoSearchComponent } from '../view/concessao/coletivo-urbano/ait-transporte/ait-transporte-search/components/button-novo-search/button-novo-search.component';
import { AutoCompleteNomeConcessionarioComponent } from "../view/concessao/coletivo-urbano/shared/auto-complete-nome-concessionario/auto-complete-nome-concessionario.component";
import { AutocompleteAgenteFormComponent } from '../view/concessao/coletivo-urbano/shared/autocomplete-agente-form/autocomplete-agente-form.component';
import { AutocompleteFindConcessionarioComponent } from '../view/concessao/coletivo-urbano/shared/autocomplete-find-concessionario/autocomplete-find-concessionario.component';
import { TextDataFimConcessaoComponent } from "../view/concessao/components/text-data-fim-concessao/text-data-fim-concessao.component";
import { TextDataInicioConcessaoComponent } from "../view/concessao/components/text-data-inicio-concessao/text-data-inicio-concessao.component";
import { TextNumeroContratoComponent } from "../view/concessao/components/text-numero-contrato/text-numero-contrato.component";
import { ConcessaoComponent } from "../view/concessao/concessao.component";
import { AutocompleteAgenteComponent } from "../view/concessao/shared/components/autocomplete-agente/autocomplete-agente.component";
import { DropdownNumeroOrdemComponent } from "../view/concessao/shared/components/dropdown-numero-ordem/dropdown-numero-ordem.component";
import { GridEquipamentoComponent } from "../view/concessao/shared/components/grid-equipamento/grid-equipamento.component";
import { GridRepresentantesComponent } from '../view/concessao/shared/components/grid-representantes/grid-representantes.component';
import { GridVistoriaComponent } from "../view/concessao/shared/components/grid-vistoria/grid-vistoria.component";
import { ButtonCadastrarComponent } from '../view/concessao/shared/components/motorista-auxiliar/components/button-cadastrar/button-cadastrar.component';
import { GridMotoristaAuxiliarComponent } from '../view/concessao/shared/components/motorista-auxiliar/components/grid-motorista-auxiliar/grid-motorista-auxiliar.component';
import { TextPrefixoComponent } from '../view/concessao/shared/components/text-prefixo/text-prefixo.component';
import { ConcessionarioPessoaFisicaComponent } from "../view/concessao/shared/concessionario-pessoa-fisica/concessionario-pessoa-fisica.component";
import { ConcessionarioPessoaJuridicaComponent } from "../view/concessao/shared/concessionario-pessoa-juridica/concessionario-pessoa-juridica.component";
import { DropdownOrgaoComponent } from "../view/concessao/shared/grl/equipamento-form/components/dropdown-orgao/dropdown-orgao.component";
import { DropdownTipoComponent } from "../view/concessao/shared/grl/equipamento-form/components/dropdown-tipo/dropdown-tipo.component";
import { TextDataFabricacaoComponent } from "../view/concessao/shared/grl/equipamento-form/components/text-data-fabricacao/text-data-fabricacao.component";
import { TextDataVencimentoComponent } from "../view/concessao/shared/grl/equipamento-form/components/text-data-vencimento/text-data-vencimento.component";
import { TextMarcaComponent } from "../view/concessao/shared/grl/equipamento-form/components/text-marca/text-marca.component";
import { TextModeloComponent } from "../view/concessao/shared/grl/equipamento-form/components/text-modelo/text-modelo.component";
import { TextNomeEquipamentoComponent } from "../view/concessao/shared/grl/equipamento-form/components/text-nome-equipamento/text-nome-equipamento.component";
import { TextNumeroSerieComponent } from '../view/concessao/shared/grl/equipamento-form/components/text-numero-serie/text-numero-serie.component';
import { AutoCompleteCidadeComponent } from "../view/concessao/shared/grl/pessoa/auto-complete-cidade/auto-complete-cidade.component";
import { DropdownCategoriaCnhComponent } from '../view/concessao/shared/grl/pessoa/dropdown-categoria-cnh/dropdown-categoria-cnh.component';
import { DropdownOrgaoExpeditorRgComponent } from '../view/concessao/shared/grl/pessoa/dropdown-orgao-expeditor-rg/dropdown-orgao-expeditor-rg.component';
import { DropdownSexoComponent } from "../view/concessao/shared/grl/pessoa/dropdown-sexo/dropdown-sexo.component";
import { DropdownSituacaoCadastroComponent } from '../view/concessao/shared/grl/pessoa/dropdown-sitaucao-cadastro/dropdown-sitaucao-cadastro.component';
import { DropdownTipoEnderecoComponent } from "../view/concessao/shared/grl/pessoa/dropdown-tipo-endereco/dropdown-tipo-endereco.component";
import { DropdownTipoLogradouroComponent } from "../view/concessao/shared/grl/pessoa/dropdown-tipo-logradouro/dropdown-tipo-logradouro.component";
import { DropdownTipoPessoaComponent } from '../view/concessao/shared/grl/pessoa/dropdown-tipo-pessoa/dropdown-tipo-pessoa.component';
import { DropdownUfRgComponent } from "../view/concessao/shared/grl/pessoa/dropdown-uf-rg/dropdown-uf-rg.component";
import { TextBairroComponent } from "../view/concessao/shared/grl/pessoa/text-bairro/text-bairro.component";
import { TextCelularComponent } from '../view/concessao/shared/grl/pessoa/text-celular/text-celular.component';
import { TextCelular2Component } from '../view/concessao/shared/grl/pessoa/text-celular2/text-celular2.component';
import { TextCepComponent } from "../view/concessao/shared/grl/pessoa/text-cep/text-cep.component";
import { TextCnhComponent } from '../view/concessao/shared/grl/pessoa/text-cnh/text-cnh.component';
import { TextCnpjComponent } from "../view/concessao/shared/grl/pessoa/text-cnpj/text-cnpj.component";
import { TextComplementoComponent } from "../view/concessao/shared/grl/pessoa/text-complemento/text-complemento.component";
import { TextCpfComponent } from "../view/concessao/shared/grl/pessoa/text-cpf/text-cpf.component";
import { TextDataNascimentoComponent } from "../view/concessao/shared/grl/pessoa/text-data-nascimento/text-data-nascimento.component";
import { TextDataPrimeiraCnhComponent } from '../view/concessao/shared/grl/pessoa/text-data-primeira-cnh/text-data-primeira-cnh.component';
import { TextDataValidadeCnhComponent } from '../view/concessao/shared/grl/pessoa/text-data-validade-cnh/text-data-validade-cnh.component';
import { TextEmailComponent } from "../view/concessao/shared/grl/pessoa/text-email/text-email.component";
import { TextLogradouroComponent } from "../view/concessao/shared/grl/pessoa/text-logradouro/text-logradouro.component";
import { TextNomeFantasiaComponent } from "../view/concessao/shared/grl/pessoa/text-nome-fantasia/text-nome-fantasia.component";
import { TextNomeComponent } from '../view/concessao/shared/grl/pessoa/text-nome/text-nome.component';
import { TextNumeroEnderecoComponent } from "../view/concessao/shared/grl/pessoa/text-numero-endereco/text-numero-endereco.component";
import { TextObservacaoPessoaComponent } from "../view/concessao/shared/grl/pessoa/text-observacao-pessoa/text-observacao-pessoa.component";
import { TextOrgaoRgComponent } from "../view/concessao/shared/grl/pessoa/text-orgao-rg/text-orgao-rg.component";
import { TextPontoReferenciaComponent } from "../view/concessao/shared/grl/pessoa/text-ponto-referencia/text-ponto-referencia.component";
import { TextRazaoSocialComponent } from "../view/concessao/shared/grl/pessoa/text-razao-social/text-razao-social.component";
import { TextRgComponent } from "../view/concessao/shared/grl/pessoa/text-rg/text-rg.component";
import { TextTelefone1Component } from "../view/concessao/shared/grl/pessoa/text-telefone1/text-telefone1.component";
import { TextTelefone2Component } from "../view/concessao/shared/grl/pessoa/text-telefone2/text-telefone2.component";
import { DropdownStatusLacreComponent } from '../view/concessao/shared/mob/lacre/dropdown-status-lacre/dropdown-status-lacre.component';
import { TextCodigoComponent } from "../view/concessao/shared/mob/lacre/text-codigo/text-codigo.component";
import { TextSerieComponent } from "../view/concessao/shared/mob/lacre/text-serie/text-serie.component";
import { AutocompletePlacaColetivoRuralComponent } from '../view/concessao/shared/mob/vistoria/autocomplete-placa-coletivo-rural/autocomplete-placa-coletivo-rural.component';
import { AutocompletePlacaComponent } from '../view/concessao/shared/mob/vistoria/autocomplete-placa/autocomplete-placa.component';
import { AutocompletePrefixoComponent } from '../view/concessao/shared/mob/vistoria/autocomplete-prefixo/autocomplete-prefixo.component';
import { DatetimeIntervaloVistoriaFinalComponent } from '../view/concessao/shared/mob/vistoria/datetime-intervalo-vistoria-final/datetime-intervalo-vistoria-final.component';
import { DatetimeIntervaloVistoriaInicialComponent } from '../view/concessao/shared/mob/vistoria/datetime-intervalo-vistoria-inicial/datetime-intervalo-vistoria-inicial.component';
import { DropdownConcessaoColetivoRuralComponent } from '../view/concessao/shared/mob/vistoria/dropdown-concessao-coletivo-rural/dropdown-concessao-coletivo-rural.component';
import { DropdownConcessaoColetivoUrbanoComponent } from '../view/concessao/shared/mob/vistoria/dropdown-concessao-coletivo-urbano/dropdown-concessao-coletivo-urbano.component';
import { DropdownConcessaoTaxiComponent } from '../view/concessao/shared/mob/vistoria/dropdown-concessao-taxi/dropdown-concessao-taxi.component';
import { ButtonNovoVeiculoComponent } from "../view/concessao/shared/veiculo-form/components/button-novo-veiculo/button-novo-veiculo.component";
import { TextPlacaComponent } from "../view/concessao/shared/veiculo-form/components/text-placa/text-placa.component";
import { PageHeaderComponent } from "../view/page-header/page-header.component";
import { ButtonCancelarArquivoConcessaoComponent } from './../view/concessao/shared/mob/arquivos-concessao-form/components/button-cancelar-arquivo-concessao/button-cancelar-arquivo-concessao.component';
import { ButtonSalvarArquivoConcessaoComponent } from './../view/concessao/shared/mob/arquivos-concessao-form/components/button-salvar-arquivo-concessao/button-salvar-arquivo-concessao.component';
import { AvatarCropperModalComponent } from './modal/avatar-cropper-modal/avatar-cropper-modal.component';
import { EmptyDataSource } from './no-datasource-data/empty-datasource.component';
import { DateVencimentoAlvaraComponent } from '../view/concessao/components/date-vencimento-alvara/date-vencimento-alvara.component';
import { TextNrProtocoloComponent } from 'app/view/concessao/components/text-nr-protocolo/text-nr-protocolo.component';
import { TextNrProtocoloTrocaVeiculoComponent } from 'app/view/concessao/components/text-nr-protocolo-troca-veiculo/text-nr-protocolo-troca-veiculo.component';
import { AnexarFotoMotoristaAuxiliarComponent } from 'app/view/concessao/taxi/taxi-form/components/anexar-foto-motorista-auxiliar/anexar-foto-motorista-auxiliar.component';

registerLocaleData(localePt);

var modules = [
  CommonModule,
  FormsModule,
  ReactiveFormsModule,
  FlexLayoutModule,
  SolComponentsAngularModule,
  SolToolsModule,
  TextMaskModule,
  /* Material imports */
  MatStepperModule,
  MatFormFieldModule,
  MatInputModule,
  MatButtonModule,
  MatCheckboxModule,
  MatButtonToggleModule,
  MatCardModule,
  MatDatepickerModule,
  MatDividerModule,
  MatAutocompleteModule,
  MatRadioModule,
  MatIconModule,
  MatSelectModule,
  MatSnackBarModule,
  MatGridListModule,
  MatMenuModule,
  MatToolbarModule,
  MatSidenavModule,
  MatListModule,
  MatTooltipModule,
  MatTableModule,
  MatPaginatorModule,
  MatSortModule,
  MatSlideToggleModule,
  MatProgressBarModule,
  MatGridListModule,
  MatExpansionModule,
  MatBadgeModule,
  MatTabsModule,
  MatProgressSpinnerModule,
  MatTreeModule,
  MatRippleModule,
  RouterModule,
  DragDropModule,
  ComponentsModule,
  ImageCropperModule
];

let declarations = [
  PageHeaderComponent,
  LabelFunctionPipe,
  InputDateDirective,
  DropdownNumeroOrdemComponent,
    //Pessoa
  AutoCompleteCidadeComponent,
  TextPlacaComponent,
  TextCnpjComponent,
  TextCpfComponent,
  TextRazaoSocialComponent,
  TextNomeFantasiaComponent,
  DropdownTipoEnderecoComponent,
  TextCepComponent,
  DropdownTipoLogradouroComponent,
  TextLogradouroComponent,
  TextNumeroEnderecoComponent,
  TextBairroComponent,
  TextComplementoComponent,
  TextPontoReferenciaComponent,
  TextTelefone1Component,
  TextTelefone2Component,
  TextCelularComponent,
  DropdownSexoComponent,
  TextRgComponent,
  TextDataNascimentoComponent,
  TextOrgaoRgComponent,
  DropdownUfRgComponent,
  DropdownSituacaoCadastroComponent,
  DropdownTipoPessoaComponent,
  TextNomeComponent,
  TextCnhComponent,
  TextDataValidadeCnhComponent,
  TextDataPrimeiraCnhComponent,
  DropdownCategoriaCnhComponent,
  TextEmailComponent,
  TextObservacaoPessoaComponent,
  TextCelular2Component,
  DropdownOrgaoExpeditorRgComponent,
    //concessao
  ConcessaoComponent,
  DropdownSituacaoConcessaoComponent,
  TextDataInicioConcessaoComponent,
  TextDataFimConcessaoComponent,
  TextNumeroContratoComponent,
  TextCodigoComponent,
  TextSerieComponent,
  DropdownStatusLacreComponent,
  ConcessionarioPessoaJuridicaComponent,
  DropdownConcessaoColetivoUrbanoComponent,
  DropdownConcessaoTaxiComponent,
  DropdownConcessaoColetivoRuralComponent,
  AutocompletePrefixoComponent,
  DatetimeIntervaloVistoriaInicialComponent,
  DatetimeIntervaloVistoriaFinalComponent,
  ButtonCadastrarComponent,
  GridMotoristaAuxiliarComponent,
  ConcessionarioPessoaFisicaComponent,
  AutocompletePlacaComponent,
  AutocompletePlacaColetivoRuralComponent,
  AutocompleteAgenteComponent,
  AutocompleteAgenteFormComponent,
  ButtonSalvarArquivoConcessaoComponent,
  ButtonCancelarArquivoConcessaoComponent,
  AutocompleteVistConcessionarioComponent,
  DropdownEnderecoComponent,
  AutocompleteVistoriaConcessionarioMototaxiComponent,
  AutocompletePlacaMototaxiComponent,
  AutocompletePlacaEscolarComponent,
  AutocompleteVistoriaConcessionarioEscolarComponent,
  AutocompleteVistoriadoFilterComponent,  
  DropdownPlacaRuralComponent,
  TextNrAitComponent,
  AnexarFotoAlvaraComponent,
  AnexarFotoMotoristaAuxiliarComponent,
  TextInscricaoMunicipalComponent,
  DateVencimentoAlvaraComponent,
  TextNrProtocoloComponent,
  TextNrProtocoloTrocaVeiculoComponent,
  //Concessionario
  GridRepresentantesComponent,
  GridEquipamentoComponent,
  GridVistoriaComponent,
  AutoCompleteNomeConcessionarioComponent,
  AutocompleteFindConcessionarioComponent,
  AutoCompleteNomePermissionarioComponent,
  //veiculo
  ButtonNovoVeiculoComponent,
  TextPrefixoComponent,
  //Equipamento
  TextNomeEquipamentoComponent,
  TextDataFabricacaoComponent,
  TextDataVencimentoComponent,
  DropdownTipoComponent,
  TextMarcaComponent,
  TextModeloComponent,
  DropdownOrgaoComponent,
  TextNumeroSerieComponent,
  //AIT
  ButtonNovoAitTransporteComponent,
  ButtonNovoSearchComponent,
  InputNormalizeDirective,
  DropdownSituacaoAitComponent,
  TipoTalaoComponent,
  AutocompleteInfracaoComponent,
  AutocompleteAgenteAitTaxiComponent,
  //Recurso
  GridRecursosComponent,
  //Infração
  TextNumeroAitFormComponent,
  TextObservacaoInfracaoComponent,
  //TALONARIO
  DropdownTalonarioTipoComponent,
  TextNumeroTalaoComponent,
  TextDataEntregaComponent,
  TextNumeroFinalComponent,
  TextNumeroInicialComponent,
  //Infração Taxi
  TextNumeroInfracaoTaxiComponent,
  EmptyDataSource,
  //PIPES
  IconeSituacaoValidade,
  //PESSOA FISICA
  ButtonSalvarComponent,
  ButtonEditarComponent,
  GridDocumentosComponent,
  ButtonCancelarComponent,
  DropdownSituacaoComponent, 
  DateAtivacaoComponent,
  DateInativacaoComponent,
  ButtonAtivarComponent, 
  ModalDesativarComponent, 
  ButtonSalvarSituacaoComponent, 
  DateFinalSituacaoComponent, 
  ButtonDesativarComponent,
  AvatarCropperModalComponent
];

@NgModule({
  declarations: [...declarations],
  imports: [...modules, 
    NgxMaskModule.forRoot()],
  exports: [...modules, ...declarations],
  entryComponents: [AvatarCropperModalComponent],
  providers: [
    LoginController,
    DatePipe, 
    DialogFactory,
    ModalService,
    { provide: DateAdapter, useClass: MomentDateAdapter },
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    { provide: MAT_DATE_FORMATS, useValue: MOMENT_DATE_FORMATS },
  ],
})
export class SharedModule {}
